import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const NavLinkWithNoStyle = styled(NavLink)`
  color: black;
  text-decoration: none;
`;
